/**
 * @param {string} elementId - the elements id attribute that this component should be initialised on
 * @param {*} Component - The Svelte Component being initialised
 * @param {{translationStrings: *}} props - (optional) Any props that the component might need
 */
export function initialiseSvelteComponent(elementId, Component, props = {}) {
    const element = document.getElementById(elementId);
    if (element) {
        const component = new Component({
            target: element,
            props,
        })
    }
}
